import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import awayBackground from '../../../assets/away.svg';
import awayDarkBackground from '../../../assets/leave-dark.svg';
import { Box } from '@mui/material';
import DayUserBookings from '../../Spaces/dayUserBookings';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles((theme) => ({
   root: {
      flexGrow: 1,
      justifyContent: 'center',
   },
}));

const AwayBlock = (props) => {
   const classes = useStyles();
   const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
   return (
      <div className={classes.root}>
         <Box
            sx={{
               width: '100%',
               height: '70vh',
               alignItems: 'start',
               backgroundImage: `url(${
                  prefersDarkMode ? awayDarkBackground : awayBackground
               })`,
               backgroundRepeat: 'no-repeat',
               backgroundPosition: 'center',
               display: 'flex',
               justifyContent: 'center',
               mt: 1,
            }}
         >
            {props.includeBookings && (
               <DayUserBookings
                  date={props.date}
                  user={props.user}
                  dayTime={props.dayTime}
                  location={location}
                  hideIfEmpty={true}
               />
            )}
         </Box>
      </div>
   );
};

export default AwayBlock;
